export default __webpack_public_path__ + "static/media/80s_block_hit_bottom.9436f19e.mp3";